"use strict";
exports.transpose = transpose;
var _index = require("./constructFrom.js");
function transpose(fromDate, constructor) {
  const date = constructor instanceof Date ? (0, _index.constructFrom)(constructor, 0) : new constructor(0);
  date.setFullYear(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate()
  );
  date.setHours(
    fromDate.getHours(),
    fromDate.getMinutes(),
    fromDate.getSeconds(),
    fromDate.getMilliseconds()
  );
  return date;
}
